module.exports = (__webpack_require__("vB+P"))(62);


//////////////////
// WEBPACK FOOTER
// delegated ../src/utils/fatch.js from dll-reference main
// module id = p3Vd
// module chunks = 73